import React from "react";
// import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import EtimesgutIntro from "../components/ServiceRegions/İntros/EtimesgutIntro";
import DynamicImage from "../components/DynamicImage";


const EtimesgutPage = () => {
  return (
    <> 
    <div>
        
      {/* <HeroSlider /> */}
      {/* <AboutSection/> */}
       <DynamicImage />
      <EtimesgutIntro/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};

export default EtimesgutPage;
